import { useRef, useEffect, useState } from 'react'

import { InsightStatusCode } from '@/types/dashboard-types'

interface UseSkeletonOnConfigChangeParams {
  status: { code: string; message?: string }
  data: unknown
  configuration: unknown
}

export function useSkeletonOnConfigChange({ status, data, configuration }: UseSkeletonOnConfigChangeParams): boolean {
  const [showSkeleton, setShowSkeleton] = useState(false)
  const hasLoadedOnce = useRef(false)
  const prevConfigJsonRef = useRef<string | null>(null)

  const configJson = JSON.stringify(configuration)

  // When data arrives, snapshot config and clear skeleton
  useEffect(() => {
    if (status.code === InsightStatusCode.DISPLAYING && data !== undefined) {
      prevConfigJsonRef.current = configJson
      hasLoadedOnce.current = true
      setShowSkeleton(false)
    }
  }, [status.code, data])

  // When config changes (not refresh), show skeleton
  useEffect(() => {
    if (hasLoadedOnce.current && prevConfigJsonRef.current !== null && prevConfigJsonRef.current !== configJson) {
      setShowSkeleton(true)
    }
  }, [configJson])

  // First load (no data yet)
  if (status.code === InsightStatusCode.LOADING && !hasLoadedOnce.current) {
    return true
  }

  return showSkeleton
}
